import { useEffect, useState } from "react";
import { Stream } from "@cloudflare/stream-react";

const FUNERAL_RECORDING_ID = "c18b4ac50890d919ab816aec69e1be1e";
const FUNERAL_POSTER_URL =
  "https://customer-n5ekme97isdmfb28.cloudflarestream.com/c18b4ac50890d919ab816aec69e1be1e/thumbnails/thumbnail.jpg?time=5s&width=1280&height=720&fit=clip";
const LIVE_INPUT_ID = "d09d613cfdf1a9cac7f46e564905a602";
const LIVE_MANIFEST_URL =
  "https://customer-n5ekme97isdmfb28.cloudflarestream.com/d09d613cfdf1a9cac7f46e564905a602/manifest/video.m3u8";

export default function LiveFuneral() {
  const [isLive, setIsLive] = useState(false);
  const [isCheckingLive, setIsCheckingLive] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const checkLiveStatus = async () => {
      try {
        const response = await fetch(LIVE_MANIFEST_URL, { cache: "no-store" });
        if (!cancelled) setIsLive(response.status === 200);
      } catch {
        if (!cancelled) setIsLive(false);
      } finally {
        if (!cancelled) setIsCheckingLive(false);
      }
    };

    checkLiveStatus();
    const interval = window.setInterval(checkLiveStatus, 15000);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);

  return (
    <section className="live-funeral" aria-labelledby="live-funeral-title">
      <div className="live-funeral__heading">
        <span className="live-funeral__cross" aria-hidden="true">✝</span>
        <p className="live-funeral__kicker">In Prayer and Remembrance</p>
        <h1 id="live-funeral-title">Live Stream</h1>
        <p>
          Watch the recorded funeral service below. When a new live broadcast
          is active, the live player will open automatically beneath it.
        </p>
      </div>

      <section className="live-funeral__recording" aria-labelledby="funeral-recording-title">
        <div className="live-funeral__section-heading">
          <p className="live-funeral__section-label">Recorded Service</p>
          <h2 id="funeral-recording-title">
            Funeral in Ottawa — 17 OCT 2026, 10:30 AM EST
          </h2>
        </div>

        <div className="live-funeral__player">
          <Stream
            controls
            src={FUNERAL_RECORDING_ID}
            poster={FUNERAL_POSTER_URL}
            responsive
            preload="metadata"
            autoplay={false}
            muted={false}
            primaryColor="#7d3f75"
            letterboxColor="#2e1c29"
            title="Funeral in Ottawa — 17 OCT 2026, 10:30 AM EST"
          />
        </div>
      </section>

      <section className="live-funeral__live" aria-labelledby="current-live-title">
        <div className="live-funeral__section-heading">
          <p className="live-funeral__section-label">Current Broadcast</p>
          <h2 id="current-live-title">Live Stream</h2>
        </div>

        {isLive ? (
          <div className="live-funeral__player">
            <Stream
              controls
              src={LIVE_INPUT_ID}
              responsive
              preload="metadata"
              autoplay={false}
              muted={false}
              primaryColor="#7d3f75"
              letterboxColor="#2e1c29"
              title="Father Paul Oneid live stream"
            />
          </div>
        ) : (
          <div className="live-funeral__waiting live-funeral__waiting--compact" role="status">
            <span className="live-funeral__waiting-icon" aria-hidden="true">◉</span>
            <h2>{isCheckingLive ? "Checking the live stream" : "No live broadcast is active"}</h2>
            <p>
              {isCheckingLive
                ? "Please wait a moment."
                : "The live player will appear here automatically when a broadcast begins."}
            </p>
          </div>
        )}
      </section>

      <div className="live-funeral__guidance">
        <h2>Watching the recording</h2>
        <ul>
          <li>Press the play button and turn on your sound.</li>
          <li>You may pause, resume, or move to any part of the service.</li>
          <li>A stable Wi-Fi or wired internet connection is recommended.</li>
        </ul>
      </div>
    </section>
  );
}
